import { Avatar, Box, Button, HStack, Image, Text } from "@chakra-ui/react";
import { colors } from "../../styles";

interface FakeInputProps {
    avatar?: string;
    nickname: string;
    description: string;
    onClick: () => void;
}

export default function FakeInput({
    avatar,
    nickname,
    description,
    onClick,
}: FakeInputProps) {
    return (
        <HStack
            width={{
                base:"100%",
                sm:"100%",
                md:"100%",
                lg:"80%",
                xl:"80%",
            }}
            justifyContent="space-between"
            alignItems="center"

            border={`0.5px solid ${colors.g4}`}
            borderRadius={"30px"}
            paddingX={5}
            paddingY={3}
            marginBottom={1}

            cursor="text"
            onClick={onClick}

            boxShadow={"0px 1px 2px 0px rgba(0, 0, 0, 0.1)"}
        >
            <HStack gap={2} alignItems="center" flex={1} minWidth={0}>
                {avatar ? (
                    <Image
                        src={avatar}
                        alt={`${nickname} 프로필 이미지`}
                        width={8}
                        height={8}
                        borderRadius="full"
                        objectFit="cover"
                        flexShrink={0}
                    />
                ) : (
                    <Image 
                        src={"/png/profile.png"}
                        alt="프로필 이미지"
                        width={8}
                        height={8}
                        borderRadius="full"
                        objectFit="cover"
                        flexShrink={0}
                    />
                )}
                <Text 
                    fontSize={14} 
                    fontWeight={400} 
                    color={colors.g3}
                    // color="transparent"
                    // background={ 
                    //     `linear-gradient(
                    //         90deg, 
                    //         ${colors.g3} 0%,
                    //         ${colors.g4} 25%, 
                    //         ${colors.blue} 50%,
                    //         ${colors.g4} 75%,
                    //         ${colors.g3} 100%
                    //     )` }
                    // backgroundClip={"text"}
                    // style={{
                    //     WebkitTextFillColor: "transparent",
                    //     WebkitBackgroundClip: "text",
                    //     backgroundSize: "300% auto",
                    //     animation: "flashy-gradient 3s linear infinite alternate",
                    // }}
                    textAlign={"center"}
                >
                    {description}
                        {/* <style>
                            {`
                                @keyframes flashy-gradient {
                                    0% {
                                        background-position: 0% 50%;
                                    }
                                    100% {
                                        background-position: 100% 50%;
                                    }
                                }
                            `}
                        </style> */}
                </Text>
            </HStack>

            <Box
                border={`0.5px solid ${colors.g4}`}
                borderRadius={"30px"}
                paddingX={4}
                paddingY={2}
                color={colors.blue}
                fontSize={14}
                fontWeight={500}
                flexShrink={0}
                cursor="pointer"
            >
                게시
            </Box>
        </HStack>
    );
}
